import { createMqStyles, tokens } from '@fhs/ui';

export const useStoreDetailsMqStyles = createMqStyles({
  root: {
    $base: {
      backgroundColor: tokens.colors.$white,
      flex: 1,
    },
  },
  // Overlaid rather than stacked: the design sits the dismiss control level with the status
  // line on desktop, and alone in a mobile app bar above it. `contentTop` reserves the room.
  closeButton: {
    $base: {
      alignItems: 'center',
      height: 40,
      justifyContent: 'center',
      position: 'absolute',
      right: 8,
      top: 8,
      width: 40,
      zIndex: 1,
    },
    $gteDesktop: {
      right: 28,
      top: 28,
    },
  },
  closeButtonHovered: {
    $base: {
      backgroundColor: tokens.colors.$blackOpacity04,
    },
  },
  scroll: {
    $base: {
      flex: 1,
    },
  },
  scrollContent: {
    $base: {
      gap: 24,
      paddingBottom: 24,
      paddingHorizontal: 16,
      paddingTop: 56,
    },
    $gteDesktop: {
      gap: 32,
      paddingHorizontal: 32,
      paddingTop: 32,
    },
  },
  summary: {
    $base: {
      gap: 6,
    },
  },
  // Desktop parts the badge from the summary a little further than the 6 between the lines
  // it sits above.
  badge: {
    $base: {
      alignSelf: 'flex-start',
      borderRadius: 4,
      paddingHorizontal: 8,
      paddingVertical: 4,
    },
    $gteDesktop: {
      marginBottom: 4,
      paddingHorizontal: 12,
      paddingVertical: 8,
    },
  },
  badgeWarning: {
    $base: {
      backgroundColor: tokens.colors.$warningBackground,
    },
  },
  badgeWarningText: {
    $base: {
      color: tokens.colors.$warning,
    },
  },
  badgeError: {
    $base: {
      backgroundColor: tokens.colors.$errorBackground,
    },
  },
  badgeErrorText: {
    $base: {
      color: tokens.colors.$error,
    },
  },
  // The one heading the design holds at 24 on both breakpoints, rather than growing it
  // with the rest of the ramp.
  storeName: {
    $gteDesktop: {
      fontSize: 24,
      lineHeight: 28,
    },
  },
  // Call and Get Directions share the row evenly, and keep doing so when only one is offered.
  actionRow: {
    $base: {
      flexDirection: 'row',
      gap: 16,
    },
  },
  // The design holds these at 40 on both breakpoints, between two of the button sizes.
  actionButton: {
    $base: {
      flexBasis: 0,
      flexGrow: 1,
      flexShrink: 1,
      minHeight: 40,
    },
  },
  serviceRow: {
    $base: {
      flexDirection: 'row',
      gap: 4,
    },
    $gteDesktop: {
      gap: 8,
    },
  },
  serviceChip: {
    $base: {
      alignItems: 'center',
      borderColor: tokens.colors.$blackOpacity10,
      borderRadius: 4,
      borderWidth: 1,
      flexBasis: 0,
      flexDirection: 'row',
      flexGrow: 1,
      gap: 4,
      justifyContent: 'center',
      paddingHorizontal: 9,
      paddingVertical: 5,
    },
    $gteDesktop: {
      gap: 8,
    },
  },
  hours: {
    $base: {
      gap: 6,
    },
    $gteDesktop: {
      gap: 8,
    },
  },
  hoursRow: {
    $base: {
      flexDirection: 'row',
      gap: 16,
      justifyContent: 'space-between',
    },
  },
  // The CTA sits on the same white as the panel. The design has no rule above the button.
  footer: {
    $base: {
      backgroundColor: tokens.colors.$white,
      paddingBottom: 32,
      paddingHorizontal: 16,
      paddingTop: 16,
    },
    $gteDesktop: {
      paddingHorizontal: 32,
      paddingTop: 24,
    },
  },
});
